module.exports = __webpack_public_path__ + "img/reduced-co2-emissions.85ef47e7.svg";